<template>
  <div class="rb-screening-s1">
    <p v-if="promptText" class="rb-ob-q">{{ promptText }}</p>
    <div class="rb-ob-choice-grid is-dense">
      <div
          v-for="opt in options"
          :key="opt.id"
          class="rb-ob-choice"
          :class="{
            'is-selected': singleValue === opt.id,
            'is-help-open': helpOpen === opt.id,
          }"
      >
        <label class="rb-ob-choice-select">
          <input
              v-model="singleValue"
              type="radio"
              :name="'sq-' + questionId"
              :value="opt.id"
              @change="onSelect"
          >
          <span class="rb-ob-choice-body">
            <span class="rb-ob-choice-title">{{ opt.label || opt.id }}</span>
            <span v-if="hintFor(opt.id)" class="rb-ob-choice-hint">{{ hintFor(opt.id) }}</span>
          </span>
        </label>
        <button
            v-if="helpFor(opt.id)"
            type="button"
            class="rb-ob-choice-help"
            :aria-expanded="helpOpen === opt.id ? 'true' : 'false'"
            :aria-label="helpAria(opt)"
            @click.stop="toggleHelp(opt.id)"
        >
          <span aria-hidden="true">؟</span>
        </button>
        <div v-if="helpFor(opt.id)" class="rb-ob-choice-popover" role="tooltip">
          {{ helpFor(opt.id) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  legacyUiKeyForS1,
  S1_EXTRA_HELP,
  S1_EXTRA_HINTS,
  S1_EXTRA_HINTS_EN,
  S1_EXTRA_HELP_EN,
} from '@/intake/screeningServiceUi'

export default {
  name: 'ScreeningParticipantSelect',
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      singleValue: '',
      helpOpen: '',
    }
  },
  computed: {
    questionId() {
      return (this.question && this.question.question_id) || 'S1'
    },
    promptText() {
      return (this.question && this.question.text) || ''
    },
    options() {
      return (this.question && Array.isArray(this.question.options))
        ? this.question.options.filter((o) => o && o.id)
        : []
    },
  },
  watch: {
    question: {
      immediate: true,
      handler() {
        this.singleValue = ((this.question.answer_prefill || {}).answer_ids || [])[0] || ''
        this.helpOpen = ''
        this.emitChange()
      },
    },
  },
  mounted() {
    document.addEventListener('click', this.closeHelp)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeHelp)
  },
  methods: {
    hintFor(optionId) {
      if (this.$route && this.$route.params.lang === 'en' && S1_EXTRA_HINTS_EN[optionId]) {
        return S1_EXTRA_HINTS_EN[optionId]
      }
      if (S1_EXTRA_HINTS[optionId]) {
        return S1_EXTRA_HINTS[optionId]
      }
      const key = legacyUiKeyForS1(optionId)
      if (!key) {
        return ''
      }
      try {
        return this.$t('intake.participantHints.' + key)
      } catch (e) {
        return ''
      }
    },
    helpFor(optionId) {
      if (this.$route && this.$route.params.lang === 'en' && S1_EXTRA_HELP_EN[optionId]) {
        return S1_EXTRA_HELP_EN[optionId]
      }
      if (S1_EXTRA_HELP[optionId]) {
        return S1_EXTRA_HELP[optionId]
      }
      const key = legacyUiKeyForS1(optionId)
      if (!key) {
        return ''
      }
      try {
        return this.$t('intake.participantHelpText.' + key)
      } catch (e) {
        return ''
      }
    },
    helpAria(opt) {
      const name = (opt && opt.label) || opt.id
      try {
        return this.$t('intake.participantHelpAria', {name})
      } catch (e) {
        return name
      }
    },
    toggleHelp(id) {
      this.helpOpen = this.helpOpen === id ? '' : id
    },
    closeHelp() {
      this.helpOpen = ''
    },
    onSelect() {
      this.helpOpen = ''
      this.emitChange()
    },
    buildPayload() {
      const required = !(this.question && this.question.required === false)
      const ids = this.singleValue ? [this.singleValue] : []
      return {
        valid: !required || ids.length > 0,
        answer_ids: ids,
      }
    },
    emitChange() {
      this.$emit('change', this.buildPayload())
    },
    getAnswer() {
      return this.buildPayload()
    },
  },
}
</script>
